import React, { useState, useEffect } from "react";
import { Switch, Route, Link, useLocation } from "react-router-dom";
import "./../styles/OurNews.scss";
import Api from "../common/api";
import leftmenuicon from "./../img/left-menu-icon-mobile.png";
const OurNews = (activeNew) => {
  const [years, setYears] = useState([]);

  const lang = localStorage.getItem("lang");

  const [months, setMonths] = useState([
    {
      id: 1,
      name: "Ocak",
      name_en:"January"
    },
    {
      id: 2,
      name: "Şubat",
      name_en:"February"
    },
    {
      id: 3,
      name: "Mart",
      name_en:"March"
    },
    {
      id: 4,
      name: "Nisan",
      name_en:"April"
    },
    {
      id: 5,
      name: "Mayıs",
      name_en:"May"
    },
    {
      id: 6,
      name: "Haziran",
      name_en:"June"
    },
    {
      id: 7,
      name: "Temmuz",
      name_en:"July"
    },
    {
      id: 8,
      name: "Ağustos",
      name_en:"August"
    },
    {
      id: 9,
      name: "Eylül",
      name_en:"September"
    },
    {
      id: 10,
      name: "Ekim",
      name_en:"October"
    },
    {
      id: 11,
      name: "Kasım",
      name_en:"November"
    },
    {
      id: 12,
      name: "Aralık",
      name_en:"December"
    },
  ]);
  const [isMobileActive, setIsMobileActive] = useState(false);
  const [currentTab, setCurrentTab] = useState([]);
  const [currentTabId, setCurrentTabId] = useState([]);
  const [currentSubTab, setCurrentSubTab] = useState([]);
  const [currentTabSubId, setCurrentSubTabId] = useState([]);
  const [newsId, setNewsId] = useState(null);
  const [isNewActive, setIsNewActive] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [datas, setData] = useState([]);
  const [filterDatas, filterData] = useState([]);
  const [activeYear, setActiveYear] = useState([]);
  const [filterMonths, setFilterMonths] = useState([]);
  const [activeMonth, setActiveMonth] = useState([]);

  const [selectedNews, setSelected] = useState([]);

  let size = 3;
  if(lang == "en"){
    size = 4;
  }
  const [activeNews, setActiveNews] = useState(
    useLocation().pathname.split("/")[size]
  );

  React.useEffect(() => {
    Api.get("/News/detail?slug=" + activeNews).then((res) => {
      setSelected(res.data);
    });
    Api.get("/News/list/1").then((res) => {
      setData(res.data.items);
      var year = [];
      res.data.items.map((val, index) => {
        var newYear = new Date(val.Created_date.split("(")[1].split(")")[0] * 1)
          .toLocaleDateString("tr-TR")
          .split(".")[2];
        if (year.findIndex((x) => x.name == newYear) == -1) {

          if(lang == "en"){
            if( val.Title_EN){
            year.push({
              id: index,
              name: newYear,
            });
          }
          }else{
            year.push({
              id: index,
              name: newYear,
            });
          }
          
        }
      });
      setYears(year);
      if(selectedNews){
        if(lang == "en"){
          if (years.findIndex((x) => x.name_en == activeNews) == -1) {
            setActiveYear(activeNews);
          }
        }else{
          if (years.findIndex((x) => x.name == activeNews) == -1) {
            setActiveYear(activeNews);
          }
        }
        
      }else{
        setActiveYear([]);
      }
      setActiveMonth([]);
      setCurrentTabId(null);
    });


  }, []);

  //  filter here
  React.useEffect(() => {
    var newmonth = [];
    var filtered = "";
    if (activeYear) {
      filtered = datas.filter((x) =>
        activeYear.length > 0
          ? new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
              .toLocaleDateString("tr-TR")
              .split(".")[2] == activeYear
          : null
      );

      var filteredSelectedmonth = months.find((m) => m.name == activeMonth);
      if (activeMonth.length != 0 && filteredSelectedmonth) {
        filtered = filtered.filter((x) =>
          activeMonth.length > 0
            ? new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
                .toLocaleDateString("tr-TR")
                .split(".")[1] == filteredSelectedmonth.id
            : null
        );
      }

      datas.filter((x, index) => {
        if(lang == "en"){
          if(x.Title_EN){
          if (
            new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
              .toLocaleDateString("tr-TR")
              .split(".")[2] == activeYear
          ) {
            var month = new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
              .toLocaleDateString("tr-TR")
              .split(".")[1];
            if (month < 10) {
              month = month.replace("0", "");
            }
            // if months is a list not add again
            if (months.findIndex((y) => x.id == month) == -1) {
              if (!newmonth.find((z) => z.id == month)) {
                if (months) {
                  newmonth.push({
                    id: months[0].id ? months.find((c) => c.id == month).id : "",
                    name: months.find((d) => d.id == month).name,
                    name_en: months.find((d) => d.id == month).name_en,
                  });
                }
              }
            }
          }
        }
        }else{
          if (
            new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
              .toLocaleDateString("tr-TR")
              .split(".")[2] == activeYear
          ) {
            var month = new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
              .toLocaleDateString("tr-TR")
              .split(".")[1];
            if (month < 10) {
              month = month.replace("0", "");
            }
            // if months is a list not add again
            if (months.findIndex((y) => x.id == month) == -1) {
              if (!newmonth.find((z) => z.id == month)) {
                if (months) {
                  newmonth.push({
                    id: months[0].id ? months.find((c) => c.id == month).id : "",
                    name: months.find((d) => d.id == month).name,
                    name_en: months.find((d) => d.id == month).name_en,
                  });
                }
              }
            }
          }
        }
       
      });

      setFilterMonths(newmonth);
      filterData(filtered);
    } else {
      filterData(datas);
    }
  }, [activeYear, activeMonth]);

  const adClick = (id) => {
    setCurrentTabId(id);
    const tab = years.find((tab) => tab.id === id);
    setCurrentTab(tab);
    setIsActive(!isActive);
    if (id == currentTabId) {
      setCurrentTabId(null);
    } else {
      setCurrentTabId(id);
    }
  };

  const allClick = () => {
    setCurrentTabId(null);
    setActiveYear([]);
  };

  return (
    <>
       <button
        onClick={() => setIsMobileActive(!isMobileActive)}
        className={!isMobileActive ? "mobile-toggle" : "mobile-toggle active"}
      >
        <img src={leftmenuicon} alt="sada" />
      </button>
      <div className="corporate-content-container full-width container-sm">
        <div className="tab-container">
          <ul>
            <li
              onClick={() => allClick()}
              className={currentTabId === null ? "years active" : "years"}
            >
              {lang == "en" ? (
              <Link to="/en/media-center/our-news">All News</Link>
              ):(
                <Link to="/medya-merkezi/haberlerimiz">Tüm Haberler</Link>
              )}
            </li>
            {years
              ? years.map((tab) => {
                  return (
                    <>
                      <div className="dropdown-calendar">
                      {selectedNews ? (
                        
                        <li
                          className={
                            currentTabId === tab.id ? "years active" : "years"
                          }
                          onBlur={() => allClick()}
                        >
                       
                       {lang == "en" ? (
                       <Link  
                            onClick={() => {
                              adClick(tab.id);
                              setActiveYear(tab.name);
                              setActiveMonth([]);
                            }}
                           to={"/en/media-center/our-news/"+tab.name}> 
                           {tab.name} News
                           </Link>   
                       ):(
                        <Link  
                             onClick={() => {
                               adClick(tab.id);
                               setActiveYear(tab.name);
                               setActiveMonth([]);
                             }}
                            to={"/medya-merkezi/haberlerimiz/"+tab.name}> 
                            {tab.name} Haberleri
                            </Link>   
                        )}
                        </li>
                      ):
                      ( 
                        lang == "en" ? (
                      <li
                        onBlur={() => allClick()}
                        className={
                          currentTabId === tab.id ? "years active" : "years"
                        }
                        onClick={() => {
                          adClick(tab.id);
                          setActiveYear(tab.name);
                          setActiveMonth([]);
                        }}
                      >
                        {tab.name} News
                      </li>):
                      (
                        <li
                          onBlur={() => allClick()}
                          className={
                            currentTabId === tab.id ? "years active" : "years"
                          }
                          onClick={() => {
                            adClick(tab.id);
                            setActiveYear(tab.name);
                            setActiveMonth([]);
                          }}
                        >
                          {tab.name} Haberleri
                        </li>)
                      )}

                        <div
                          className={
                            currentTabId === tab.id
                              ? "months-dropdown active"
                              : "months-dropdown"
                          }
                        >
                          <ul>
                            {filterMonths
                              ? filterMonths.map((tab) => {
                                  return (
                                    <li
                                      onClick={() => setActiveMonth(tab.name)}
                                      className={
                                        activeMonth === tab.name
                                          ? "dark-tab"
                                          : null
                                      }
                                    >
                                      {lang =="en" ? tab.name_en: tab.name}
                                    </li>
                                  );
                                })
                              : null}
                          </ul>
                        </div>
                      </div>
                    </>
                  );
                })
              : null}
          </ul>
        </div>
       

        <div className={!isMobileActive ? "mobile-tabs-corporate" : "mobile-tabs-corporate active"}>
          <ul>
            <li
              onClick={() => allClick()}
              className={currentTabId === null ? "years active" : "years"}
            >
              {lang == "en" ? (
              <Link to="/en/media-center/our-news">All News</Link>
              ):(
                <Link to="/medya-merkezi/haberlerimiz">Tüm Haberler</Link>
              )}
            </li>
            {years
              ? years.map((tab) => {
                  return (
                    <>
                      <div className="dropdown-calendar">
                      {selectedNews ? (
                        
                        <li
                          className={
                            currentTabId === tab.id ? "years active" : "years"
                          }
                          onBlur={() => allClick()}
                         
                        >
                       <Link  
                            onClick={() => {
                              adClick(tab.id);
                              setActiveYear(tab.name);
                              setActiveMonth([]);
                            }}
                           to={"/medya-merkezi/haberlerimiz/"+tab.name}> 
                           {tab.name} Haberleri
                           </Link>   
                        </li>
                      ):
                      ( <li
                        onBlur={() => allClick()}
                        className={
                          currentTabId === tab.id ? "years active" : "years"
                        }
                        onClick={() => {
                          adClick(tab.id);
                          setActiveYear(tab.name);
                          setActiveMonth([]);
                        }}
                      >
                        {tab.name} Haberleri
                      </li>)}

                        <div
                          className={
                            currentTabId === tab.id
                              ? "months-dropdown active"
                              : "months-dropdown"
                          }
                        >
                          <ul>
                            {filterMonths
                              ? filterMonths.map((tab) => {
                                  return (
                                    <li
                                      onClick={() => {
                                        setActiveMonth(tab.name)
                                        setIsMobileActive(false)
                                      }}
                                      className={
                                        activeMonth === tab.name
                                          ? "dark-tab"
                                          : null
                                      }
                                    >
                                      {tab.name}
                                    </li>
                                  );
                                })
                              : null}
                          </ul>
                        </div>
                      </div>
                    </>
                  );
                })
              : null}
          </ul>
        </div>

       
          <div className="corporate-container">
          <h3>{lang == "en" ? "Our News" : "Haberlerimiz"}</h3>
          {selectedNews ? (
            lang ==  "en" ? (
            selectedNews.Title_EN ? (
              <div className="new-container white">
              <div className="new-content-box">
                <h5>
                  {selectedNews.Created_date
                    ? new Date(
                        selectedNews.Created_date.split("(")[1].split(")")[0] *
                          1
                      ).toLocaleDateString("tr-TR")
                    : null}
                </h5>
                <h4>{ selectedNews.Title_EN}</h4>
                <img
                  src={"https://sankoenerji.com.tr" + selectedNews.Image}
                  alt=""
                  className="new-img-box"
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html:selectedNews.Content_EN,
                  }}
                ></p>
              </div>
            </div>
            ):""
            ):(
              selectedNews.Title ? (
              <div className="new-container white">
              <div className="new-content-box">
                <h5>
                  {selectedNews.Created_date
                    ? new Date(
                        selectedNews.Created_date.split("(")[1].split(")")[0] *
                          1
                      ).toLocaleDateString("tr-TR")
                    : null}
                </h5>
                <h4>{selectedNews.Title}</h4>
                <img
                  src={"https://sankoenerji.com.tr" + selectedNews.Image}
                  alt=""
                  className="new-img-box"
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: selectedNews.Content,
                  }}
                ></p>
              </div>
            </div>
            ):""
            )
           

          ) : filterDatas ? (
            filterDatas.map((data) => (
              lang ==  "en" ? (
                data.Title_EN ? (
              <div key={data.id} className="new-container news-list">
                <div className="new-img-box">
                  {data.Image ? (
                    <img
                      src={"https://sankoenerji.com.tr" + data.Image}
                      alt=""
                    />
                  ) : null}
                </div>
                <div className="new-content-box">
                  <h5>
                    {data.Created_date
                      ? new Date(
                          data.Created_date.split("(")[1].split(")")[0] * 1
                        ).toLocaleDateString("tr-TR")
                      : null}
                  </h5>
                  <h4>{data.Title_EN}</h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: data.Spot_EN,
                    }}
                  ></p>
                </div>
                <button style={{ textDecoration: "none", color: "black" }}>
                  <a href={"/en/media-center/our-news/" + data.Slug_EN}>
                    read more
                  </a>
                </button>
              </div>
              ):""
              ):(

                data.Title ? (
                <div key={data.id} className="new-container news-list">
                <div className="new-img-box">
                  {data.Image ? (
                    <img
                      src={"https://sankoenerji.com.tr" + data.Image}
                      alt=""
                    />
                  ) : null}
                </div>
                <div className="new-content-box">
                  <h5>
                    {data.Created_date
                      ? new Date(
                          data.Created_date.split("(")[1].split(")")[0] * 1
                        ).toLocaleDateString("tr-TR")
                      : null}
                  </h5>
                  <h4>{data.Title}</h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: data.Spot,
                    }}
                  ></p>
                </div>
                <button style={{ textDecoration: "none", color: "black" }}>
                  <a href={"/medya-merkezi/haberlerimiz/" + data.Slug}>
                    Haberin devamı için tıklayın
                  </a>
                </button>
              </div>
              ):""
              )
            ))
          ) : null}
          <div className="pagination">
            <a href="#">1</a>
            <a href="#">2</a>
            <a href="#">3</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurNews;
